<!--
 * @Description:子表单
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="drag-sub-form-item-title" :style="{ maxWidth: 'calc(100% - 20px)' }">
    <div class="drag-field-icon">
      <qfei-icon-more-two-outlined class="mover drag-mover" />
      <component class="filed-icon" :is="QfeiIconSubFormOutlined" />
    </div>
    <div class="sub-form-title-box">
      <xl-label-text cursor="pointer" :value="props?.element?.label" :row="1" />
    </div>

    <jw-tooltip v-if="props?.element?.toast">
      <qfei-icon-question-mark-outlined size="14" />
      <!-- 这是提示文本  -->
      <template #content> {{ props?.element.toast }} </template>
    </jw-tooltip>
    <qf-icon-required v-if="props?.element?.isRequired" />
  </div>
  <div class="drag-item-content drag-sub-item-content scrollbar-style-config">
    <div class="drag-sub-item-content-35">
      <draggable v-if="props?.element?.modules?.length" :group="{ name: 'subItxst', sort: true, put: false, pull: false }" animation="500" :list="props?.element.modules" class="drag-sub-item-content-ele" :key="subIndex" ghostClass="ghost-sub-class">
        <template #item="{ element: subElement, index: subIndex }">
          <div :class="['drag-item-list', data.editFieldObj?.value == subElement?.value && subElement?.value ? 'item-sub-click' : 'not-item-sub-click']" @click.stop.prevent="setConfig($event, subElement, subIndex)">
            <span class="drag-item-label">
              <qf-icon-required v-if="subElement?.isRequired" />{{ subElement?.label }}
              <template v-if="subElement?.toast">
                <jw-tooltip>
                  <qfei-icon-question-mark-outlined size="14" />
                  <!-- 这是提示文本  -->
                  <template #content>
                    {{ subElement.toast }}
                  </template>
                </jw-tooltip>
              </template>
            </span>
            <!-- 字段组件 -->
            <field-modules :list="props?.element" :modules="subElement" source="35" :parentIndex="parentIndex" :itemIndex="i" :subIndex="subIndex"></field-modules>

            <!--附加说明 -->
            <div class="sub-tips" v-if="subElement?.memo">
              {{ subElement?.memo }}
            </div>
          </div>
        </template>
      </draggable>
    </div>
    <div class="empty-content" v-if="!props?.element?.modules || !props?.element?.modules?.length">
      <jw-empty :description="$t('请添加字段')" />
    </div>
  </div>
</template>

<script setup>
import draggable from 'vuedraggable';
import { QfeiIconMoreTwoOutlined, QfeiIconQuestionMarkOutlined, QfeiIconSubFormOutlined } from '@qfei-design/icons-vue';
import { reactive, inject, onMounted, provide } from 'vue';
import fieldModules from '@/views/setting/sys-fields/page-layout/components/field-modules/field-modules.vue';
const getParentMetheds = inject('publicMethods');
const sendModule = getParentMetheds?.sendModule || (() => {}); //父组件方法--同步数据给父组件
const clearSubFormStatus = getParentMetheds?.clearSubFormStatus || (() => {}); //清空子字段选中状态
const props = defineProps({
  element: {
    //数据
    type: Object,
    default: () => {
      return {};
    }
  },
  parentIndex: {
    //父级索引
    type: Number || String,
    default: 0
  },
  index: {
    //子集索引
    type: Number || String,
    default: 0
  },
  formAttribute: {
    type: Object
  }
});

const data = reactive({
  editFieldObj: {} //当前被编辑的字段信息
});
onMounted(() => {
  data.editFieldObj = {};
});
const setConfig = async (e, callbackData, subIndex) => {
  clearSubFormStatus();
  data.editFieldObj = callbackData;
  sendModule(e, callbackData, props.parentIndex, props.index, subIndex);
};
provide('publicSubMethods', {
  selectSubModules: setConfig
});
// 清空选中
const setClickStatus = () => {
  data.editFieldObj = {};
};
defineExpose({ setClickStatus });
</script>

<style scoped lang="less">
@import './sub-form-table.less';
</style>
